import { ErrorIcon404 } from '@/assets/theme/default/errorsIcons';
import { ErrorBlock } from '@/components/blocks/errors/ErrorBlock/ErrorBlock';
import { RESPONSE_ERROR_PHRASES } from '@/consts/phrases/errorPhrases';
import { usePhrase } from '@/hooks/general/usePhrase/usePhrase';

export const Error404 = () => {
    const { t } = usePhrase();

    return (
        <ErrorBlock
            icon={<ErrorIcon404 />}
            title={t(RESPONSE_ERROR_PHRASES.PAGE_NOT_FOUND)}
            text={t(RESPONSE_ERROR_PHRASES.PAGE_NOT_FOUND_DESCRIPTION)}
        />
    );
};
